/**
 * Documentation Panel Component
 *
 * Full-page modal overlay wrapping the shared DocsContent renderer.
 * Content lives in ./sections/*.mdx, the same sections served on the
 * public /docs page.
 */

import { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import DocsContent from './DocsContent';
import { DEFAULT_SECTION } from './registry';

function DocsPanel({ visible, onClose }) {
  const { user } = useAuth();
  const [activeSection, setActiveSection] = useState(DEFAULT_SECTION);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.7)',
        zIndex: 10000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: '#1a1f2e',
        border: '1px solid #2a3344',
        borderRadius: '12px',
        width: '90vw',
        maxWidth: '1100px',
        height: '85vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 20px',
          borderBottom: '1px solid #2a3344',
          flexShrink: 0,
        }}>
          <h2 style={{ margin: 0, fontSize: '16px', color: '#e0e0e0' }}>Documentation</h2>
          <button
            onClick={onClose}
            style={{
              padding: '4px 10px',
              borderRadius: '4px',
              border: '1px solid #2a3344',
              background: 'transparent',
              color: '#8a9ab0',
              fontSize: '14px',
              cursor: 'pointer',
              lineHeight: 1,
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = '#ff4a4a'}
            onMouseLeave={(e) => e.currentTarget.style.color = '#8a9ab0'}
          >
            ✕
          </button>
        </div>

        <DocsContent
          activeSection={activeSection}
          onSelectSection={setActiveSection}
          role={user?.role}
        />
      </div>
    </div>
  );
}

export default DocsPanel;
